module.exports = __webpack_public_path__ + "static/media/stay_grey_filled.cc57130a.svg";